import { Injectable } from "@angular/core";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { KYMW7402Model } from "../kymw7402.model";

/** レスポンス構造 */
export type GetRememberGoodsInfoResponce = {
  RememberGoodsId: string;
  RememberGoodsStatus: string;
  ItemCode: string;
  MasterPrice: string;
  GuideGoodsName: string;
  GuideStandardName: string;
  OrderNum: string;
  OrderChangeOrderNum: string;
  IncreaseGoods: string;
  RememberCategoryCode: string;
  OrderReceptionStartCatalog: string;
  OrderReceptionEndCatalog: string;
  DeliveryStartCatalog: string;
  DeliveryEndCatalog: string;
  DeliveryCycleDiv: string;
  MonthlyDeliveryTimes: string;
  GoodsCatalogDiv: string;
  PauseGroupCode: string;
  CoopCodeList: Array<string>;
  DetailInfoList: {
    ApplicableStartCatalog: string;
    ApplicableEndCatalog: string;
    PauseDelivery: string;
    DiscountType: string;
    DiscountUnitPrice: string;
    DiscountRate: string;
    RememberGoodsName: string;
    RememberGoodsNameKana: string;
    RememberStandardName: string;
    RememberStandardNameKana: string;
  }[];
}

/**
 * 忘れず注文商品情報取得
 * 
 */
@Injectable()
export class GetRememberGoodsInfoService extends PlessJsonResponderSub<GetRememberGoodsInfoResponce> {

  private model: KYMW7402Model;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   * 
   */
  private getBody() {
    return new PlessRequest({
      parameter: {
        ItemCode: this.model.itemCode,
        RememberGoodsId: this.model.rememberGoodsId,
      }
    })
  }

  /**
   * API呼び出し
   * 
   * @param model 
   * @param successFunc 
   */
  execute(model: KYMW7402Model, successFunc: Function = null) {
    this.model = model;
    this.successFunc = successFunc;
    this.send('getRememberGoodsInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   * @param data 
   */
  success(data: GetRememberGoodsInfoResponce): void {
    this.model.setRememberGoodsInfo(data);
    if ( this.successFunc !== null ) {
      this.successFunc(data);
    }
  }
}